import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Dropdown } from 'react-bootstrap';
import './languageSelector.css';

const LanguageSelector = () => {
  const { i18n } = useTranslation();
  const [currentLang, setCurrentLang] = useState(i18n.language || 'en');

  const languages = {
    en: { flag: '🇺🇸', name: 'English' },
    pt: { flag: '🇧🇷', name: 'Português' },
    es: { flag: '🇪🇸', name: 'Español' }
  };

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
    setCurrentLang(lng);
    localStorage.setItem('i18nextLng', lng);
  };

  return (
    <Dropdown className="language-selector">
      <Dropdown.Toggle variant="" id="language-dropdown" className="language-toggle">
        <span className="flag-icon">{languages[currentLang]?.flag || '🇺🇸'}</span>
        <span className="lang-code">{currentLang.toUpperCase()}</span>
      </Dropdown.Toggle>

      <Dropdown.Menu>
        {Object.entries(languages).map(([code, { flag, name }]) => (
          <Dropdown.Item
            key={code}
            onClick={() => changeLanguage(code)}
            active={currentLang === code}
            className="language-item"
          >
            <span className="flag-icon">{flag}</span>
            <span className="lang-name">{name}</span>
          </Dropdown.Item>
        ))}
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default LanguageSelector;

